import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest, putRequest } from "../services/apiMethods";
import { useLocation } from "react-router-dom";

const PaymentPending = () => {
  const location = useLocation();
  const userId = new URLSearchParams(location.search).get("userId");
  const isUpgradeMode = new URLSearchParams(location.search).get("upgrade") === "true";


  // Fetch subscriptions
  const { data: subscriptionsData, isLoading: isSubscriptionsLoading } =
    useQuery({
      queryKey: ["subscriptions"],
      queryFn: () => getRequest("/subscription/list"),
    });

  // Fetch user detail
  const { data: userDetail, isLoading: isUserLoading } = useQuery({
    queryKey: ["userDetail", userId],
    queryFn: () => getRequest(`/user/detail/${userId}`),
    enabled: !!userId,
    onSuccess: () => sessionStorage.setItem("userId", userId),
  });

  // Checkout mutations
  const { mutate: createCheckout, isLoading: isCheckoutLoading } = useMutation({
    mutationFn: (payload) =>
      postRequest("/transaction/createCheckoutSession", payload),
    onSuccess: (res) => {
      if (res?.status === 200) {
        sessionStorage.setItem("userId", userId);
        sessionStorage.setItem("upgrade", isUpgradeMode.toString());
        window.location.href = res?.url?.trim() || "/stripe-success";
      }
    },
  });

  const { mutate: upgradeCheckout, isLoading: isUpgradeLoading } = useMutation({
    mutationFn: (payload) =>
      putRequest(`/user/upgradeSubscription/${userId}`, payload),
    onSuccess: (res) => {
      if (res?.status === 200) {
        sessionStorage.setItem("userId", userId);
        sessionStorage.setItem("upgrade", isUpgradeMode.toString());
        window.location.href = res?.url?.trim() || "/stripe-success";
      }
    },
  });

  const handleSubscribe = (priceId) => {
    createCheckout({ userId, priceId });
  };

  const handleUpgradeSubscribe = (subscriptionId) => {
    upgradeCheckout({ subscriptionId });
  };

  if (isSubscriptionsLoading || isUserLoading) return <p>Loading...</p>;

  // 🔑 Map subscription order for easy comparison
  const planOrder = { Bronze: 1, Gold: 2, Platinum: 3 };

  const currentPlanTitle = userDetail?.result?.subscriptionId?.title || null;
  const currentRank = currentPlanTitle ? planOrder[currentPlanTitle] : null;
  const isSubscriptionActive = userDetail?.result?.isSubscription === 1;

  // Map hardcoded plans to API data
  const getSubscriptionByTitle = (title) => {
    return subscriptionsData?.subscriptions?.find(sub =>
      sub.title.toLowerCase() === title.toLowerCase()
    );
  };

  const getButtonConfig = (planTitle) => {
    const subscription = getSubscriptionByTitle(planTitle);
    if (!subscription) return { label: "Subscribe", handler: null, disabled: true };

    const isCurrentPlan = currentPlanTitle === subscription.title;

    if (isCurrentPlan && isSubscriptionActive) {
      return { label: "Current Plan", handler: null, disabled: true };
    }

    // If upgrade=true in URL, always use upgrade API
    if (isUpgradeMode) {
      return {
        label: "Subscribe",
        handler: () => handleUpgradeSubscribe(subscription._id),
        disabled: isUpgradeLoading
      };
    }

    // If user has any active subscription, use upgrade API for any other plan
    if (isSubscriptionActive) {
      return {
        label: "Subscribe",
        handler: () => handleUpgradeSubscribe(subscription._id),
        disabled: isUpgradeLoading
      };
    }

    // No active subscription, use create API
    return {
      label: "Subscribe",
      handler: () => handleSubscribe(subscription.stripePriceId),
      disabled: isCheckoutLoading
    };
  };

  console.log('Code Updated');

  return (
    <>
      <section className="commn-bg-set only-one-respo padding-added-80">
        <div className="card-center-set ">
          <div className="commn-card-theme">
            <img
              className="side-logo-set"
              src={require("../Assets/images/logo-main.png")}
            />
            <h2>Our Subscriptions</h2>
            <p>A plan to suit every palette</p>
            <div className="subscriptions-plans">
              <ul>
                {subscriptionsData?.subscriptions?.map((subscription, index) => {
                  const config = getButtonConfig(subscription.title);
                  return (
                    <li key={subscription._id} className={index === subscriptionsData.subscriptions.length - 1 ? "mb-0" : ""}>
                      <div>
                        <h3>{index + 1}</h3>
                        <div className="subscriptions-price">
                          <h4>{subscription.title}</h4>
                          <h5>£{subscription.price} / {subscription.periodUnit}</h5>
                          <p>{subscription.description}</p>
                          <ul className="subscription-features mt-2">
                            <li className="mb-2">✔ Free Drinks Per Day: {subscription.freeDrinksPerDay}</li>
                            <li className="m-0">✔ Free Drinks Per Week: {subscription.freeDrinksPerWeek}</li>
                          </ul>
                        </div>
                      </div>
                      <button
                        className="highlighted"
                        onClick={config.handler}
                        disabled={config.disabled}
                      >
                        {config.label}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="commn-bg-set only-one-respo">
        <div className="subscription-container">
          {subscriptionsData?.subscriptions?.map((plan, index) => {
            const cardClass =
              ["bronze", "gold", "platinum"][index] || "default";

            const isCurrentPlan = currentPlanTitle === plan.title;
            const targetRank = planOrder[plan.title];

            let buttonLabel = "Subscribe";
            let actionHandler = () => handleSubscribe(plan.stripePriceId);

            if (isCurrentPlan) {
              if (isSubscriptionActive) {
                buttonLabel = "Current Plan";
                actionHandler = null;
              } else {
                buttonLabel = "Subscribe";
                actionHandler = () => handleSubscribe(plan._id);
              }
            } else if (currentRank) {
              if (targetRank > currentRank) {
                buttonLabel = "Upgrade";
                actionHandler = () => handleUpgradeSubscribe(plan._id);
              } else if (targetRank < currentRank) {
                buttonLabel = "Downgrade";
                actionHandler = () => handleUpgradeSubscribe(plan._id);
              }
            }

            return (
              <div key={plan._id} className={`subscription-card ${cardClass}`}>
                <h2 className="subscription-title">{plan.title}</h2>

                <div className="subscription-price">
                  £{plan.price} / {plan.periodUnit}
                </div>

                <p className="subscription-description">{plan.description}</p>

                <ul className="subscription-features">
                  <li>✔ Free Drinks Per Day: {plan.freeDrinksPerDay}</li>
                  <li>✔ Free Drinks Per Week: {plan.freeDrinksPerWeek}</li>
                </ul>

                <button
                  className="subscription-btn"
                  onClick={actionHandler}
                  disabled={
                    !actionHandler || isCheckoutLoading || isUpgradeLoading
                  }
                >
                  {buttonLabel}
                </button>
              </div>
            );
          })}
        </div>
      </section> */}
    </>
  );
};

export default PaymentPending;
